import { css } from "@emotion/react";

export const goodsSliderDesign = () => {
  return {
    root: css`
      width: 90%;
      padding-top: 20px;
      margin: 0 auto 16px;
      @media screen and (min-width: 768px) {
        width: calc(65% - 17px);
        padding-top: 0;
        margin-right: 34px;
        margin-bottom: 0;
      }
      .mainImage {
        margin-bottom: 15px;
        img {
          width: calc(100% - 1px);
          border: 2px solid #e5e5e5;
        }
      }
    `,
  };
};

export const thumbnailListStyle = css`
  display: grid;
  flex-wrap: wrap;
  margin-top: 42px;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
`;

export const thumbnailBaseStyle = css`
  height: auto;
`;

export const notActiveThumbnailStyle = css`
  border: 2px solid #e5e5e5;
`;

export const activeThumbnailStyle = css`
  border: 2px solid #00c2ae;
`;

export const buttonStyle = css`
  background-color: transparent;
  border: none;
  cursor: pointer;
  height: 100%;
`;

export const thumbnailImageStyle = css`
  max-width: 100%;
  vertical-align: middle;
`;
